

// If there is a toggle
if ( biro_page_contents_toggle !== null ) {


	// Listen for links being clicked
	document.addEventListener( 'click', function( e ) {

		if ( e.target.classList.contains( 'page-contents-link' ) ) {

			// Stop the link being followed so we can control the scroll
			e.preventDefault();

			// Hide the expander menu
			biro_page_contents_expander_list_wrap.style.display = 'none';

			// Flag that the menu is not expanded
			biro_page_contents_toggle.setAttribute( 'aria-expanded', 'false' );
			biro_page_contents_expander.classList.remove( 'is-expanded' );

			// Get the href of the clicked link
			let linkHref = e.target.getAttribute( 'href' );

			// Scroll to that point
			scrollToHash( linkHref );

			// Add the URL hash
			window.history.pushState( {}, '', window.location.origin + window.location.pathname + linkHref );

		}

	});

	// Set a debounce timer variable
	let debounce_timer = true;

	// When the window scrolls
	window.onscroll = function () {

		// If there's a debounce time already in operation
		if ( debounce_timer ) {

			// Clear the timeout
			window.clearTimeout( debounce_timer );

			// Set a function to run after a timeout
			debounce_timer = window.setTimeout( function () {

				// If the bottom of the expander header is further down the page than the top of the in-page list
				if ( biro_page_contents_expander_header.getBoundingClientRect().bottom > biro_page_contents_list_in_page.getBoundingClientRect().top ) {

					// Mark the expander as active
					biro_page_contents_expander.classList.add( 'is-active' );

					// Otherwise the bottom of the header is above the top of the inline list
				} else {

					// Mark the expander as inactive
					biro_page_contents_expander.classList.remove( 'is-active' );

					// Hide the menu
					biro_page_contents_expander_list_wrap.style.display = 'none';

					// Flag that the menu is not expanded
					biro_page_contents_toggle.setAttribute( 'aria-expanded', 'false' );
					biro_page_contents_expander.classList.remove( 'is-expanded' );

				}

				// Loop through the links in the dropdown
				document.querySelectorAll( '#page-contents-list-expander a' ).forEach( function ( element ) {

					// Remove any current classes
					element.classList.remove( 'current' );

				} );

				// Create a variable for the last link tested
				let current_link = false;

				// Loop through the jump links in the dropdown
				// Working from the links rather than from every h2 in the content means headings
				// the list doesn't know about - block templates render their own - are ignored
				document.querySelectorAll( '#page-contents-list-expander a[ href^="#" ]' ).forEach( function ( link ) {

					// Find the heading this link points at
					let heading = document.getElementById( link.getAttribute( 'href' ).substring( 1 ) );

					// If the top of the heading is more than halfway up the page
					if ( heading !== null && heading.getBoundingClientRect().top < ( window.innerHeight / 2 ) ) {

						// Set the last link tested to this one
						current_link = link;

					}

				} );

				// If there's a link (there might not be when scrolling to the top)
				if ( current_link ) {

					// Add the 'current' class to it
					current_link.classList.add( 'current' );

				}

			}, 100 );
		}
	};

	// Add a hover event listeners on the toggle
	biro_page_contents_toggle.addEventListener( 'mouseover', function ( event ) {

		// Add class to expander header
		biro_page_contents_expander_header.classList.add( 'toggle-hover' );

	});
	biro_page_contents_toggle.addEventListener( 'mouseout', function ( event ) {

		// Remove class from expander header
		biro_page_contents_expander_header.classList.remove( 'toggle-hover' );

	});

	// Add a click event listener on the toggle
	biro_page_contents_toggle.addEventListener( 'click', function ( event ) {

		// Is the expander active?
		if ( biro_page_contents_expander.classList.contains( 'is-active' ) ) {

			// If the menu isn't expanded
			if ( biro_page_contents_toggle.getAttribute( 'aria-expanded' ) === 'false' ) {

				// Define the max height as the window height
				navMaxHeight = window.innerHeight;

				// Remove the height of the mobile header
				navMaxHeight -= biro_mobile_header.getBoundingClientRect().height;

				// Remove the height of the expander header
				navMaxHeight -= biro_page_contents_expander_header.getBoundingClientRect().height;

				// If the admin bar is there
				if ( adminBar = document.querySelector( '#wpadminbar' ) ) {

					// Remove the height of the admin bar
					navMaxHeight -= adminBar.getBoundingClientRect().height;

				}

				// Set the max-height property
				// +1 is for a border somewhere
				biro_page_contents_expander_list_wrap.style.maxHeight = ( navMaxHeight + 1 ) + 'px';

				// Display it
				biro_page_contents_expander_list_wrap.style.display = 'block';

				// Flag that the menu is expanded
				biro_page_contents_toggle.setAttribute( 'aria-expanded', 'true' );
				biro_page_contents_expander.classList.add( 'is-expanded' );

				// Otherwise the menu is expanded
			} else {

				// Hide the menu
				biro_page_contents_expander_list_wrap.style.display = 'none';

				// Flag that the menu is not expanded
				biro_page_contents_toggle.setAttribute( 'aria-expanded', 'false' );
				biro_page_contents_expander.classList.remove( 'is-expanded' );

			}

			// Remove focus from toggle
			biro_page_contents_toggle.blur();

		}

	} );

}
